const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=epic%20abstract%20fantasy%20adventure%20visual%2C%20warm%20golden%20and%20amber%20dramatic%20lighting%2C%20grand%20cinematic%20scale%2C%20artistic%20epic%20atmosphere%2C%20soft%20warm%20gradient%2C%20no%20text%20no%20people&width=1200&height=500&seq=carousel-01-2026&orientation=landscape',
    title: '古装玄幻巨制',
    desc: '热门IP改编，顶级特效打造东方奇幻世界',
    tag: '热播中',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=suspenseful%20abstract%20crime%20thriller%20visual%2C%20dramatic%20warm%20orange%20lighting%2C%20tense%20cinematic%20mood%2C%20artistic%20mystery%20atmosphere%2C%20dark%20warm%20gradient%2C%20no%20text%20no%20people&width=1200&height=500&seq=carousel-02-2026&orientation=landscape',
    title: '悬疑烧脑剧场',
    desc: '高智商犯罪推理，每一帧都是线索',
    tag: '口碑推荐',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=romantic%20abstract%20urban%20love%20story%20visual%2C%20soft%20warm%20golden%20hour%20lighting%2C%20gentle%20emotional%20cinematic%20mood%2C%20artistic%20romance%20atmosphere%2C%20warm%20gradient%2C%20no%20text%20no%20people&width=1200&height=500&seq=carousel-03-2026&orientation=landscape',
    title: '都市情感剧场',
    desc: '现实题材走心之作，引发全民共鸣',
    tag: '热播中',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=futuristic%20abstract%20sci-fi%20visual%2C%20dramatic%20warm%20amber%20and%20gold%20lighting%2C%20epic%20cinematic%20scale%2C%20artistic%20science%20fiction%20atmosphere%2C%20warm%20gradient%2C%20no%20text%20no%20people&width=1200&height=500&seq=carousel-04-2026&orientation=landscape',
    title: '科幻灾难大片',
    desc: '硬核科幻场面震撼，视觉奇观不容错过',
    tag: '即将上线',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=colorful%20abstract%20animated%20visual%2C%20bright%20warm%20golden%20lighting%2C%20playful%20cinematic%20mood%2C%20artistic%20animation%20atmosphere%2C%20soft%20warm%20gradient%2C%20no%20text%20no%20people&width=1200&height=500&seq=carousel-05-2026&orientation=landscape',
    title: '国漫崛起专题',
    desc: '国产动画精品力作，画面剧情双双在线',
    tag: '编辑精选',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=nostalgic%20abstract%20classic%20cinema%20visual%2C%20soft%20vintage%20warm%20golden%20lighting%2C%20retro%20cinematic%20mood%2C%20artistic%20classic%20film%20atmosphere%2C%20warm%20gentle%20gradient%2C%20no%20text%20no%20people&width=1200&height=500&seq=carousel-06-2026&orientation=landscape',
    title: '经典电影回顾',
    desc: '那些年我们追过的神作，百看不厌',
    tag: '经典重温',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            精选影视专题策划，发现更多精彩内容
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item, i) => (
            <article key={i} className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer">
              <div className="relative aspect-[21/9] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-primary-500 text-white text-xs font-medium">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}